import { LogoPropsType } from './logoTypes';

export default function HSBCLogo({ monochrome, className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 119 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0725 0V16V32L0 16L16.0725 0Z"
        fill={monochrome ? 'currentColor' : '#DA000A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0712 0H31.9613H47.9726L31.9613 16.0743L16.0103 0.0606L16.0712 0Z"
        fill={monochrome ? 'currentColor' : '#DA000A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.9241 32V16V0L63.9968 16L47.9241 32Z"
        fill={monochrome ? 'currentColor' : '#DA000A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.9253 32H32.0353H16.0239L32.0353 15.9258L47.9863 31.9394L47.9253 32Z"
        fill={monochrome ? 'currentColor' : '#DA000A'}
      />
      <path
        d="M69.1584 22.6109H72.1118V16.9903H77.8236V22.6109H80.7769V9.21094H77.8236V14.674H72.1118V9.21094H69.1584V22.6109Z"
        fill={monochrome ? 'currentColor' : 'black'}
      />
      <path
        d="M82.3794 18.4545C82.3981 21.6832 84.8565 22.9109 87.6459 22.9109C91.1766 22.9109 93.4065 21.1654 93.4065 18.707C93.4065 15.6668 90.4372 15.1458 89.4175 14.8409C86.1888 13.8752 85.7281 13.6964 85.7281 12.664C85.7281 11.5378 86.84 11.0314 87.75 11.0314C89.0431 11.0314 89.845 11.6084 89.9748 12.9635H92.9268C92.9666 10.066 90.816 8.9668 87.8775 8.9668C85.3048 8.9668 82.6623 10.2056 82.6623 12.9455C82.6623 15.4604 84.7618 16.2173 86.6697 16.8116C88.7678 17.4651 90.2354 17.4757 90.2354 18.9208C90.2354 20.2346 88.8121 20.7339 87.8113 20.7339C86.3688 20.7339 85.4444 20.078 85.3606 18.4545L82.3794 18.4545Z"
        fill={monochrome ? 'currentColor' : 'black'}
      />
      <path
        d="M97.8207 16.7553H100.239C101.503 16.7553 102.533 17.2997 102.533 18.6696C102.533 20.0584 101.375 20.5462 100.185 20.5462H97.8207V16.7553ZM94.9282 22.6109H100.532C103.099 22.6109 105.668 21.6911 105.668 18.8385C105.668 17.1682 104.582 16.0232 102.634 15.6853C104.424 15.1222 105.177 14.0712 105.177 12.7575C105.177 10.2615 103.044 9.21094 100.648 9.21094H94.9282V22.6109ZM97.8207 11.3319H99.9687C100.994 11.3319 102.17 11.7635 102.17 13.0396C102.17 14.1656 101.195 14.7848 100.188 14.7848H97.8207V11.3319Z"
        fill={monochrome ? 'currentColor' : 'black'}
      />
      <path
        d="M118.695 13.2449C118.565 10.5383 116.382 8.92969 113.31 8.92969C109.166 8.92969 106.821 11.7262 106.821 15.9674C106.821 20.5082 108.978 22.9113 113.31 22.9113C116.364 22.9113 118.533 21.2567 118.667 18.6048H115.625C115.337 20.0121 114.459 20.6403 113.179 20.6403C110.703 20.6403 109.878 18.2382 109.878 16.0047C109.878 13.659 110.834 11.2194 113.347 11.2194C114.632 11.2194 115.473 12.1703 115.558 13.2449H118.695Z"
        fill={monochrome ? 'currentColor' : 'black'}
      />
    </svg>
  );
}
